export const getEnumValuesRegex = (enumObject: Record<string, string>) => {
  return new RegExp(`^(${Object.values(enumObject).join('|')})$`);
};
